import React from 'react';

import { monthNames } from '@src/common/calendar';
import useTranslate from '@src/i18n/useTranslate';
import MonthThumb from '@src/domains/scheduling/components/MonthThumb';
import { Container, YearlyViewMonthArea, YearlyViewMonthAreaInner, YearlyViewMonthName } from './styles';

interface CalendarYearViewProps {
  year: number;
  onMonthClick: (month: [number, number]) => void;
}

const CalendarYearView = (props: CalendarYearViewProps) => {
  const { year, onMonthClick } = props;

  const { i18n } = useTranslate();

  return (
    <Container>
      {monthNames.map((month, index) => (
        <YearlyViewMonthArea key={index} onClick={() => onMonthClick([year, index + 1])}>
          <YearlyViewMonthAreaInner>
            <YearlyViewMonthName>{i18n(month)}</YearlyViewMonthName>

            <MonthThumb monthTuple={[year, index + 1]} size='compact' />
          </YearlyViewMonthAreaInner>
        </YearlyViewMonthArea>
      ))}
    </Container>
  );
};

export default CalendarYearView;
